<template>
  <div>
    <AppToolbox
      @refresh="onRefresh"
      :search.sync="search"
      :selectedItem="selectedItem"
      :formData="scopedFormData"
      :detailData="scopedDetailData"
      :filterData="scopedFilterData"
      :apiUrl="apiUrl">

      <template #filter="scope">
        <div class="row">
          <div class="col">
            <v-select
              v-model="scope.data.companyId"
              :options="listOptions.companies"
              :reduce="item => item.ID"
              placeholder="Instansi / OPD"
              @input="onChangeCompany"
              label="Name"/>
          </div>
          <!-- <div class="col">
            <v-select
              v-model="scope.data.employeeTypeId"
              :options="listOptions.employeeTypes"
              :reduce="item => item.ID"
              placeholder="Tipe Pegawai"
              @input="onChangeEmployeeType"
              label="Name"/>
          </div> -->
        </div>
      </template>

      <template #form="scope">
        <div class="form-group">
          <label>Nama Kategori</label>
          <input class="form-control d-block w-100" v-model="scope.data.Name">
        </div>

        <div class="form-group">
          <label>Tanggal Mulai</label>
          <b-form-datepicker v-model="scope.data.StartDate" locale="id" class="mb-2" />
        </div>

        <div class="form-group">
          <label>Tanggal Berakhir</label>
          <b-form-datepicker v-model="scope.data.EndDate" locale="id" class="mb-2" />
        </div>

        <div class="form-group">
          <label>Instansi / OPD</label>
          <v-select
            v-model="scope.data.CompanyID"
            :options="listOptions.companies"
            :reduce="item => item.ID"
            label="Name"/>
        </div>

        <!-- <div class="form-group">
          <label>Tipe Pegawai</label>
          <v-select
            v-model="scope.data.EmployeeTypeID"
            :options="listOptions.employeeTypes"
            :reduce="item => item.ID"
            label="Tipe Pegawai"/>
        </div> -->

        <div class="form-group">
          <label>Urutan Prioritas</label>
          <input class="form-control d-block w-100" v-model.number="scope.data.PriorityOrder" @keydown="$helper.inputRestrictNumber">
        </div>

        <button class="btn btn-primary btn-sm btn-block" type="submit">Simpan</button>
      </template>

    </AppToolbox>

    <AppTable
      :apiUrl="apiUrl"
      :fields="tableFields"
      :filter="scopedFilterData"
      :search="search"
      @onSelectItem="selectedItem = $event" />
  </div>
</template>

<script>
import AppToolbox from '@/components/app/AppToolbox.vue'
import AppTable from '@/components/app/AppTable.vue'

export default {
  components: { AppToolbox, AppTable },
  mounted() {
    this.onRefresh()

    this.loadOptionData()

    if (!this.isApprover) {
      this.scopedFilterData.companyId = JSON.parse(localStorage.getItem('userData')).employee.CompanyID
    }
  },
  data() {
    return {
      apiUrl: '/attendance-weekly-schedule-category',
      tableFields: [
        { key: 'index', label: 'No.' },
        { key: 'Name', label: 'Nama Kategori' },
        { key: 'StartDate', label: 'Tanggal Mulai', formatter: value => this.$helper.formatDate(value) },
        { key: 'EndDate', label: 'Tanggal Akhir', formatter: value => this.$helper.formatDate(value) },
        { key: 'Company', label: 'Instansi / OPD', formatter: value => value ? value.Name : '' },
        // { key: 'EmployeeType', label: 'Tipe Pegawai', formatter: value => value ? value.Name : '' },
        { key: 'PriorityOrder', label: 'Urutan Prioritas' }
      ],
      selectedItem: null,
      search: '',
      scopedFormData: {
        ID: null,
        CompanyID: JSON.parse(localStorage.getItem('userData')).employee.CompanyID,
        // EmployeeTypeID: JSON.parse(localStorage.getItem('userData')).employee.EmployeeTypeID,
        Name: '',
        StartDate: (new Date()),
        EndDate: (new Date()),
        CompanyID: null,
        // EmployeeTypeID: null,
        PriorityOrder: null
      },
      scopedDetailData: {},
      scopedFilterData: {
        companyId: null,
        // employeeTypeId: null
      },
      listOptions: {
        companies: [],
        // employeeTypes: []
      }
    }
  },
  methods: {
    onRefresh () {
      this.$emit('refreshTable')
    },

    onChangeCompany (value) {
      const categoryUrl = `/attendance-weekly-schedule-category?companyId=${value}`
      this.$axios.get(categoryUrl).then((res) => {
        this.listOptions.weeklyScheduleCategories = res.data
        this.$emit('refreshTable')
      })
    },

    loadOptionData () {
      this.$axios.get('/company').then((res) => {
        this.listOptions.companies = res.data
      })
      // this.$axios.get('/employee-type').then((res) => {
      //   this.listOptions.employeeTypes = res.data
      // })
    },
  }
}
</script>
